/**
 *
 * @type {{GREETING: string}}
 */
export const VIDEO_TYPE = {
  GREETING: 'GREETING',
};

export const VIDEO_PROVIDER = {
  VIMEO: 'VIMEO',
  BUNNY: 'BUNNY',
};
